export default "__VITE_ASSET__ihq_aZ64__"